import React, { useMemo } from 'react';

import { useNavigateLink } from '~/shared';
import { Button } from '~/shared/components';

export const ButtonLink = React.memo(({ navigateTo, fallback, external = false, ...buttonProps }) => {
  const computeNavigateTo = useMemo(() => {
    if (navigateTo?.startsWith('/')) return navigateTo;
    return `/${navigateTo}`;
  }, [navigateTo]);
  const { getNavigateFn } = useNavigateLink(computeNavigateTo);

  let navigateFn = getNavigateFn();

  if (navigateTo) return <Button {...buttonProps} onClick={() => navigateFn(computeNavigateTo)} />;
  navigateFn = getNavigateFn(fallback);
  return <Button {...buttonProps} onClick={() => navigateFn(fallback)} />;
});
